import React from "react";

const ModernLoader = ({ 
  size = "medium", 
  text = "Loading...", 
  variant = "primary",
  className = "" 
}) => {
  const sizeClasses = {
    small: "w-6 h-6",
    medium: "w-12 h-12", 
    large: "w-16 h-16"
  };

  const variantClasses = {
    primary: "border-emerald-600",
            secondary: "border-emerald-600",
    success: "border-green-600",
    warning: "border-yellow-600",
    danger: "border-red-600"
  };

  return (
    <div className={`flex flex-col items-center justify-center space-y-4 ${className}`}>
      <div className="relative">
        {/* Main spinner */}
        <div className={`${sizeClasses[size]} border-4 border-gray-200 rounded-full animate-spin`}>
          <div className={`absolute top-0 left-0 w-full h-full border-4 border-transparent border-t-current rounded-full ${variantClasses[variant]}`}></div>
        </div>
        
        {/* Pulsing dot in center */}
        <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-current rounded-full animate-pulse ${variantClasses[variant].replace('border-', 'bg-')}`}></div>
      </div>
      
      {text && (
        <div className="text-center">
          <p className="text-sm font-medium text-gray-600 animate-pulse">{text}</p>
        </div>
      )}
    </div>
  );
};

export default ModernLoader; 